import cx from 'classnames';
import React from 'react';

import { Spinner } from 'components/Spinner';

type Props = {
  isLoading: boolean;
  fallbackText: string;
  className?: string;
};

export const VtbProbeStatus: React.FC<Props> = ({
  isLoading,
  fallbackText,
  className,
}) => {
  if (isLoading) {
    return (
      <div
        className={cx(
          className,
          'tw-h-[54px] tw-flex tw-items-center tw-justify-center',
        )}
      >
        <Spinner />
      </div>
    );
  }

  return (
    <div
      className={cx(
        className,
        'tw-text-center tw-text-gray-600 tw-text-sm tw-py-3',
      )}
    >
      {fallbackText}
    </div>
  );
};
